import type { IBaseModel } from '../../../data/model';
import { ProductViewedEvent, RequestQuoteInitiatedEvent } from '../../../products/ProductFamilyPageEvents';
import type { StoreState } from '../../../StoreState';
import { IEventAggregator } from '../../EventAggregator';
import { Analytics } from '../Analytics';
import { ProductDataConverter } from '../converters/ProductDataConverter';

export class ProductFamilyAnalyticsListener {
  constructor(
    eventAggregator: IEventAggregator,
    private readonly getStore: () => StoreState,
  ) {
    eventAggregator.subscribe(ProductViewedEvent, (e) => this.onProductViewed(e));
    eventAggregator.subscribe(RequestQuoteInitiatedEvent, (e) => this.onRequestQuoteInitiated(e));
  }

  private onProductViewed(e: ProductViewedEvent) {
    const { price } = e.product;
    const quantity = 1;

    Analytics.trackViewProduct({
      currency: price.currency.code,
      value: price.amount * quantity,
      product: ProductDataConverter.fromBaseModelBasicData(
        e.product,
        this.canBePurchased(e.product),
        e.configurationCode,
        price.amount,
        quantity,
      ),
    });
  }

  private onRequestQuoteInitiated(e: RequestQuoteInitiatedEvent) {
    Analytics.trackActivateLead({
      currency: e.currencyCode,
      product: ProductDataConverter.fromBaseModelBasicData(
        e.product,
        this.canBePurchased(e.product),
        e.configurationCode,
        undefined,
        1,
      ),
    });
  }

  private canBePurchased(product: IBaseModel) {
    return this.getStore().canBePurchased(product);
  }
}
